import React, { useState } from 'react';
import { Modal, Box, IconButton, Backdrop } from '@mui/material';
import { Close, ZoomIn } from '@mui/icons-material';
import './Lightbox.css';

const Lightbox = ({
  image,
  width = '100%',
  height = '100%',
  alt = 'Imagem',
  className = ''
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* Thumbnail clicável */}
      <div
        className={`lightbox-thumbnail ${className}`}
        style={{ width, height, cursor: 'pointer', position: 'relative' }}
        onClick={handleOpen}
      >
        <img
          src={image}
          alt={alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: 'inherit'
          }}
        />
        {/* Overlay com ícone de zoom */}
        <div className="lightbox-overlay">
          <ZoomIn className="zoom-icon" />
        </div>
      </div>

      {/* Modal do Lightbox */}
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.9)' }
        }}
        sx={{
          zIndex: 1000000
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '95vw',
            maxHeight: '95vh',
            outline: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {/* Botão de fechar */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: { xs: 10, sm: -50 },
              right: { xs: 10, sm: -50 },
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: '#EC5569',
                color: 'white'
              },
              zIndex: 1
            }}
          >
            <Close />
          </IconButton>

          {/* Imagem ampliada */}
          <img
            src={image}
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)'
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Lightbox;
